// Copyright (c) StrangeBee 2023

import { getFileDatastoreUrl } from '@Helpers/';
import { ReactElement, memo, useEffect, useState } from 'react';
import { Buffer } from 'buffer';

interface ThumbnailImageProps {
    id: string;
    contentType: string;
}
export const ThumbnailImage = memo(({ id, contentType }: ThumbnailImageProps): ReactElement => {
    const [src, setSrc] = useState('');

    useEffect(() => {
        const fileLocation = window.location.origin + getFileDatastoreUrl(id);

        fetch(fileLocation)
            .then((response) => {
                if (response.ok) {
                    return response.arrayBuffer();
                }

                throw new Error('error during fetching Image');
            })
            .then((text) => {
                setSrc(`data:${contentType};base64,` + Buffer.from(text).toString('base64'));
            });
    }, [contentType, id]);

    return (
        <figure className="Comment__ThumbnailContainer">
            <img src={src} alt="" role="none" className="Comment__Thumbnail" loading="lazy" />
        </figure>
    );
});
